<template>
  <bvue-ui-view :scroll="true" class="border-radius">
    <div class="flex justify-end">
      <button class="icon icon-cross icon-2x mt-1 mb-1" @click="$bvueUi.modal.close()"></button>
    </div>
    <div class="flex flex-1 flex-col items-center justify-center" v-if="state == 'default'">
      <h3>{{ $t('comprarsemillas') }}
        <b v-if="$i18n.locale === 'es'">{{reserve.name}}</b>
        <b v-if="$i18n.locale === 'en'">{{reserve.name_us}}</b>
        <b v-if="$i18n.locale === 'de'">{{reserve.name_de}}</b>
      </h3>
      <div class="flex-1">
        <p class="text-center px-4" > {{ $t('porcadasemilla') }} </p>
        <div class="greyBox w-full flex items-center">
          <img :src="require('@/assets/images/seed.svg')" class="seedImg mr-2">
          <label class="flex-1">{{ $t('semillascant') }}         
            <b v-if="$i18n.locale === 'es'">{{reserve.name}}</b>
            <b v-if="$i18n.locale === 'en'">{{reserve.name_us}}</b>
            <b v-if="$i18n.locale === 'de'">{{reserve.name_de}}</b></label>
          <label>{{price.toFixed(2)}} $</label>
        </div>
        <div class="form-group flex-1 mt-4">
          <label class="ml-2">{{ $t('semillasmin') }}</label>
          <div class="flex counter-container">
            <input type="number" :min="1" :max="seeds.length" class="form-input resize" v-model.number="count" @input="countChanged"/>
            <div class="flex form-group justify-center items-center resize-total">
              <label class="ml-3">{{ $t('totaldonacion') }}</label>
              <label class="ml-1">{{total.toFixed(2)}} $</label>
            </div>
          </div>
        </div>
        <div class="sm:flex">
          <div class="flex flex-col flex-1 haveSeed mr-3 h-full mt-1">
            <div class="flex flex-1 mt-4 h-full text-center">
              <label class="flex-1">{{ $t('dispongo') }}</label>
            </div>
            <div class="flex w-full mt-1 h-full flex-1 justify-center">
              <div class="w-full flex enter-code">
                <input type="text" class="form-input flex text-center form-code" v-model="ticket" maxlength="19" placeholder="4RE2-F45W-E9XU-C8AE">
              </div>
            </div>
          </div>
          <div class="sm:flex flex-col mt-3">
            <div class="flex items-center justify-center">
              <label class="form-switch flex">
                <input type="checkbox" v-model="terms">
                <i class="form-icon"></i> {{ $t('aceptolos') }} <a href="http://arbola.redforestal.org/terms_and_conditions_arbola.html" target="blank">{{ $t('terminos') }}</a>
              </label>
            </div>
            <div class="w-full flex items-center justify-center mt-1 mb-4">
             <button id="donarsemillas" class="btn btn-primary w-full js-paymentez-checkout" @click="buy" :disabled="!terms">{{ $t('donarsem') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-1 flex-col items-center justify-center" v-if="state == 'loading'">
      <div class="">
        {{ $t('cargando') }}
      </div>
    </div>
    <div class="flex flex-1 flex-col items-center justify-center" v-if="state == 'success'">
      <i class="material-icons outputIcon iconSuccess mb-4">check_circle</i> 
      <h1> {{ $t('donacioncorrecta') }}</h1>
      <p class="text-center px-4">{{ $t('transaccionexito') }}</p>
    </div>
    <div class="flex flex-1 flex-col items-center justify-center" v-if="state == 'error'">
      <i class="material-icons outputIcon iconError mb-4">cancel</i> 
      <h1>{{ $t('donacionnorealizada') }}</h1>
      <p class="text-center px-4">{{ $t('problematarjeta') }}</p>
    </div>
  </bvue-ui-view>
</template>

<script>

import firebase from '@/firebase'
import swal from 'sweetalert'

export default {
  name: 'BuySeeds',
  props: {
    modalData: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$ga.page('/Donar Semillas');
  },
  data() {
    return {
      dispongo: false,
      terms: false,
      count: 1,
      ticket: '',
      loading: [],
      paymentezCheckout: null,
      transaction: null,
      transactionRef: null,
      cancelling: false,
      state: 'default',
      // Referencia al handler de popstate para poder removerlo al destruir el componente
      _popstateHandler: null,
    }
  },
  destroyed() {
    this.cancelTransaction()
    // Remover el listener de popstate para evitar fugas de memoria
    if (this._popstateHandler) {
      window.removeEventListener('popstate', this._popstateHandler)
      this._popstateHandler = null
    }
  },
  created() {
    this.paymentezCheckout = new PaymentezCheckout.modal({
      client_app_code: process.env.PAY_APP_CODE,
      client_app_key: process.env.PAY_APP_KEY,
   
      locale: 'en',

      env_mode: process.env.PAY_ENV,
    
      // Fix P2: arrow function para que `this` apunte al componente Vue
      onOpen: () => {
        this.state = 'loading'
        console.log('modal open')
      },
      onClose: () => {
          console.log('modal closed')
          this.cancelTransaction()
          if (this.state == 'loading') {
            this.state = 'default'
          }
      },
      onResponse: (response) => {
        if (response.transaction && response.transaction.status === 'success' && response.transaction.authorization_code) {
          this.state = 'success'
          this.transaction.state = 'paid'
          if (this.transactionRef) {
            this.transactionRef.update({
              state: 'paid',
              paymentez: response,
              updatedAt: new Date().getTime(),
            })
            // Fix P1: La asignación de semillas ahora se hace server-side
            // en la Cloud Function updateTransaction, no desde el cliente.
            // Esto garantiza que las semillas se asignan aunque el usuario
            // cierre el navegador después de pagar.
            this.transaction = null
            this.transactionRef = null
          }
        } else {
          this.state = 'error'
          this.transaction.state = 'error'
          if (this.transactionRef) {
            this.transactionRef.update({
              state: 'error',
              error: response.error || {},
              paymentez: response,
              updatedAt: new Date().getTime(),
            })
            this.transaction = null
            this.transactionRef = null
          }
        }      
      }
    });

    // Fix P2: guardar referencia al handler para poder removerlo en destroyed()
    this._popstateHandler = () => {
      console.log('popstate')
      if (this.paymentezCheckout) {
        this.paymentezCheckout.close()
      }
    }
    window.addEventListener('popstate', this._popstateHandler);
  },
  computed: {
    // Fix P2: computeds ya no cierran el modal como side effect.
    // Retornan valores por defecto seguros si faltan datos.
    userId() {
      if (this.$store.state.auth.user) {
        return this.$store.state.auth.user.uid
      }
      return null
    },
    userEmail() {
      if (this.$store.state.auth.user) {
        return this.$store.state.auth.user.email
      }
      return null
    },
    // Fix P2: no mutar la prop modalData.reserveId dentro del computed
    effectiveReserveId() {
      return this.modalData.reserveId || this.$store.state.reservaAct
    },
    reserve() {
      if (this.$store.state.reserves.items) {
        return this.$store.state.reserves.items[this.effectiveReserveId] || {}
      }
      return {}
    },
    price() {
      // Fix P2: null-safe para profile.country que no exista en countries.items
      const profile = this.$store.state.auth.profile
      const countries = this.$store.state.countries.items
      if (profile && countries) {
        const countryData = countries[profile.country]
        const conversion = (countryData && countryData.conversion) || 1
        return parseFloat(this.reserve.price || 0) * parseFloat(conversion)
      }
      return parseFloat(this.reserve.price || 0)
    },
    total() {
      return parseFloat((this.price * this.count).toFixed(2))
    },
    seeds() {
      return this.$store.getters.reserveUnplantedSeeds(this.effectiveReserveId)
    }
  },
  methods: {
    countChanged() {
      if (this.count > this.seeds.length) {
        this.count = this.seeds.length
      }
      if (this.count < 1) {
        this.count = 1
      }
    },
    async cancelTransaction() {
      if (this.transactionRef && this.transaction && this.transaction.state === 'unpaid' && !this.cancelling) {
        this.cancelling = true
        try {
          const stored = (await this.transactionRef.get()).data()
          if (stored && stored.state === 'unpaid') {
            await this.transactionRef.update({
              state: 'cancelled',
              updatedAt: new Date().getTime(),
            }) 
          }
        } catch (error) {
          console.error('Error cancelling transaction:', error)
        }
        this.transaction = null
        this.transactionRef = null
        this.cancelling = false
      }
    },
    async buy() {
      // Validar que el usuario está logueado
      if (!this.userId) {
        swal("Atención!", "Debes iniciar sesión para donar.");
        return
      }

      // Canje de serial (Cloud Function)
      if (this.ticket.length > 0) {
        this.loading = ['loading', 'disabled']
        try {
          const idToken = await firebase.auth().currentUser.getIdToken()
          const functionsUrl = process.env.NODE_ENV === 'production'
            ? 'https://us-central1-red-forestal.cloudfunctions.net'
            : 'http://localhost:5001/red-forestal/us-central1'

          const response = await fetch(`${functionsUrl}/redeemSerial`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${idToken}`,
            },
            body: JSON.stringify({
              ticket: this.ticket,
              reserveId: this.effectiveReserveId
            }),
          })

          const result = await response.json()

          this.loading = []

          if (result.success) {
            swal("¡Felicitaciones!", "Tienes una semilla asignada, procede a apadrinar un árbol en el mapa!");
            this.$bvueUi.modal.close()
          } else {
            if (result.error === 'invalid_ticket') {
              swal("Atención!", "...el código ingresado es incorrecto!");
            } else if (result.error === 'used_ticket') {
              swal("Atención!", "...el código ingresado ya fue utilizado!");
            } else if (result.error === 'no_seeds_available') {
              swal("Atención!", "No hay semillas disponibles en esta reserva.");
            } else {
              swal("Error", "Error al procesar el código: " + (result.error || 'Desconocido'));
            }
          }
        } catch (error) {
          console.error("Error redeeming serial:", error)
          this.loading = []
          swal("Error", "No se pudo procesar el código. Revisa tu conexión.");
        }
        return // Termina la ejecución (no pasa al flujo de pago)
      }

      // Flujo de compra con tarjeta
      if (this.count > this.seeds.length) {
        this.count = this.seeds.length
      }
      if (this.count < 1) {
        this.count = 1
      }
      var buySeeds = []
      for (let i = 0; i < this.count; i++) {
        buySeeds.push(this.seeds[i].id)
      } 

      // Create transaction record
      this.transaction = {
        userId: this.userId,
        reserveId: this.effectiveReserveId,
        amount: this.total,
        createdAt: new Date().getTime(),
        updatedAt: new Date().getTime(),
        state: 'unpaid',
        seeds: buySeeds
      }
      this.transactionRef = await firebase.firestore().collection('transactions').add(this.transaction)

      // Open Paymentez Checkout
      this.paymentezCheckout.open({
        user_id: this.userId,
        user_email: this.userEmail,
        user_phone: '',
        order_description: `${this.count} semillas para ${this.reserve.name}`,
        order_amount: this.total,
        order_vat: 0,
        order_reference: this.transactionRef.id,
      });
   
      this.loading = ['loading', 'disabled']
    },
  },
}
</script>


<style>
.greyBox {
  background-color: rgba(255,204,0,0.3);
  border-radius: 10px;
}
.haveSeed {
  min-height: 20px;
  font-size: 0.65rem;
}

.enter-code {
  width: 200px;  
}

.form-code {
  font-size: 0.7rem;
  border-radius: 15px !important;
  height: 30px;
  background: white !important;
  color: #808080;
}

.resize {
  min-width: 85px;
  max-width: 80%;
}

.resize-total {
  white-space: nowrap;
}

i.material-icons.outputIcon {
  font-size: 5.4em;
}
.iconSuccess {
  color: #AAC92D;
}

.iconError {
  color: #F44336;
}
.paymentez-checkout-modal {
  z-index: 2000 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/modals/BuySeeds.vue